var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAction = function SvgAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4121 9.03906H21.4121L11.4121 24.0391V15.0391H4.41211L13.4121 0.0390625V9.03906ZM11.4121 11.0391V7.25906L7.94411 13.0391H13.4121V17.4331L17.6751 11.0391H11.4121Z"
  })));
};
export default SvgAction;